import React, {forwardRef, ReactNode, useImperativeHandle, useRef, useEffect} from "react";
import Dialog from "@mui/material/Dialog";
import CloseIcon from '@mui/icons-material/Close';
import {
  DialogContent,
  DialogTitle,
  IconButton,
  Stack, Theme,
  Typography
} from "@mui/material";
import _ from "lodash";
import {SxProps} from "@mui/system";

export interface FaModalInfoProps {
  title?: string | null,
  maxWidth: 'xs' | 'sm' | 'md' | 'lg' | 'xl',
  onAccept?: () => void,
  buttonTextAccept?: string,
  onOk?: () => void,
  buttonTextOk?: string,
  onReject?: () => void,
  buttonTextReject?: string,
  children?: ReactNode,
  showClose?: boolean,
  isOpen?: boolean,
  noHeader?: boolean,
  footer?: ReactNode,
  setIsOpen?: (open: boolean) => void;
  outsideClick?: () => void;
  sx?: SxProps<Theme>;
}

const FaModalInfo = forwardRef<any, FaModalInfoProps>((
    {
      title,
      maxWidth,
      showClose,
      children,
      isOpen,
      setIsOpen,
      outsideClick,
      noHeader,
      sx
    }, ref) => {

  const [open, setOpen] = React.useState(isOpen || false);
  const modalRef = useRef<any>();

  // Sync internal state with external isOpen prop
  React.useEffect(() => {
    if (isOpen !== undefined) {
      setOpen(isOpen);
    }
  }, [isOpen]);

  const handleClose = () => {
    setOpen(false);

    if (setIsOpen) {
      setIsOpen(false);
    }

    if (outsideClick) {
      outsideClick();
    }
  };

  useImperativeHandle(ref, () => ({
    show() {
      setOpen(true);
    },
    handleClose,
    modalRef: modalRef.current
  }));

  return (
      <Dialog
          ref={modalRef}
          onClose={handleClose}
          open={open}
          maxWidth={maxWidth}
          fullWidth
          sx={sx}
          disableRestoreFocus
          disableEnforceFocus
      >
        {
            !noHeader &&
          <>
            <DialogTitle sx={{py: 1, px: 2, backgroundColor: 'transparent'}}>
              {/*@ts-ignore*/}
              <Stack direction={'row'} justifyContent={'space-between'} width={1} padding={0}>
                <Typography flexGrow={1} sx={{my: 'auto'}} variant={"h4"} color={"primary"}>{title}</Typography>
                {
                    (showClose ?? true) &&
                  <IconButton aria-label="close" size="small" color={'secondary'} onClick={handleClose}>
                    <CloseIcon/>
                  </IconButton>
                }
              </Stack>
            </DialogTitle>
          </>
        }
        <DialogContent className={'dialog-content'} sx={{padding: '16px 16px 20px 16px !important'}}>
          {children}
        </DialogContent>
      </Dialog>
  );
});
FaModalInfo.displayName = 'FactureeModalInfo';
export default FaModalInfo;
